/* RDF Custom JS
   Theme: Woodstock
   Stand: 2026-09
*/


/* =========================================================
   MOBILE OPTIMIERUNG
   Nach - und & folgt auf Mobile Textumbruch in Slideshow 
   ========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  const applyMobileBannerBreak = () => {
    if (window.innerWidth > 749) return;

    document.querySelectorAll('.banner__text').forEach((el) => {
      if (el.dataset.rdfBreakApplied === 'true') return;

      let html = el.innerHTML;

      html = html.replace('–', '<br>–');
      html = html.replace('&amp;', '<br>&amp;');

      el.innerHTML = html;
      el.dataset.rdfBreakApplied = 'true';
    });
  };

  applyMobileBannerBreak();
});



/* =========================================================
   DESKTOP-FILTER ÖFFNEN
   Auf der Produktübersicht wird am Desktop automatisch die Filteroptionen geöffnet
   ========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  // Mobil unverändert lassen
  if (window.innerWidth < 990) return;

  setTimeout(() => {
    const elements = document.querySelectorAll('button, summary, a');

    const filterButton = Array.from(elements).find((el) =>
      el.textContent
        .trim()
        .toLowerCase()
        .includes('filter anzeigen')
    );

    if (filterButton) {
      filterButton.click();
    }
  }, 500);
});



/* =========================================================
   DESKTOP-HAUPTMENÜ
   Permanente Active-Linie durch Theme-Hovereffekt ersetzen
   ========================================================= */

(() => {
  const fixHeaderMenuUnderlines = (root = document) => {
    root
      .querySelectorAll(
        '.header__inline-menu summary.header__menu-item--top > span.header__active-menu-item.underlined-link'
      )
      .forEach((label) => {
        label.classList.replace(
          'underlined-link',
          'link-effect-no-underline'
        );
      });
  };

  const initHeaderMenuFix = () => {
    fixHeaderMenuUnderlines(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initHeaderMenuFix,
      { once: true }
    );
  } else {
    initHeaderMenuFix();
  }

  /* Damit es auch nach einer Neuladung des Headers
     im Shopify-Theme-Editor bestehen bleibt */
  document.addEventListener('shopify:section:load', (event) => {
    fixHeaderMenuUnderlines(event.target);
  });
})();